import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/home/components/banner-section/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsSection"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/home/components/NewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoboSection"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/home/components/RoboSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollDownButton"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/home/components/scroll-down-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/AIPredictionIcon.svg");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/DynamicStrategyIcon.svg");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/earth-image.svg");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/robo1.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/robo2.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/stockmining-en.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/stockmining-zh.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/sub1.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/sub2.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/home/subscription-logo.svg");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Balancer"] */ "/builds/tradingvalley-frontend/growin/node_modules/react-wrap-balancer/dist/index.mjs");
